import { render, staticRenderFns } from "./AudioRecordingInput.vue?vue&type=template&id=4ef58473"
import script from "./AudioRecordingInput.vue?vue&type=script&lang=ts"
export * from "./AudioRecordingInput.vue?vue&type=script&lang=ts"
import style0 from "./AudioRecordingInput.vue?vue&type=style&index=0&id=4ef58473&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports